// extracted by mini-css-extract-plugin
export var centerText = "_5a-8";
export var container = "_5a-0";
export var doughnutContainer = "_5a-7";
export var legend = "_5a-a";
export var legendItemColorDisplay = "_5a-b";
export var legendItemLabel = "_5a-d";
export var legendItemValue = "_5a-c";
export var lg = "_5a-5";
export var maxWidth = "_5a-9";
export var md = "_5a-4";
export var responsive = "_5a-6";
export var sm = "_5a-3";
export var xs = "_5a-2";
export var xxs = "_5a-1";